import formatMoney from "lib/formatMoney";
import dayjs from "dayjs";

const CalculatorQuestions = [
  {
    q_id: "0",
    q_title: "Loan start",
    q_description: (answers) => {
      return "Do you know when you will approximately start making payments on this loan?";
    },
    node_type: "node",
    a_type: "date",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) {
        return false; //isValid
      }
      return true; //isValid
    },
    q_invalid_answer_help_text: "Please enter a value above 0",
    a_error: false,
  },
  {
    q_id: "00",
    q_title: "Home insurance",
    q_description: () => {
      return "What is actual or estimated annual insurance on the dwelling? What is the frequency of payments? What size monthly cushion do you want to apply (many lenders use 2 as default)? When is the first payment date?";
    },
    node_type: "node",
    a_type: "escrowRow",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) {
        return false; //isValid
      }
      return true; //isValid
    },
    q_invalid_answer_help_text: "Please enter a value above 0",
    a_error: false,
  },
  {
    q_id: "000",
    q_title: "Mortgage insurance",
    q_description: () => {
      return "What is actual or estimated annual mortgage insurance if any? What is the frequency of payments? What size monthly cushion do you want to apply (many lenders use 2 as default)? When is the first payment date?";
    },
    node_type: "node",
    a_type: "escrowRow",
    // a_input_type: "number",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) {
        return false; //isValid
      }
      return true; //isValid
    },
    q_invalid_answer_help_text: "Please enter a value above 0",
    a_error: false,
  },
  {
    q_id: "0000",
    q_title: "County tax",
    q_description: () => {
      return "Enter annual county real estate tax. What is the frequency of payments? What size monthly cushion do you want to apply (many lenders use 2 as default)? When is the first payment date?";
    },
    node_type: "node",
    a_type: "escrowRow",
    // a_input_type: "number",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) {
        return false; //isValid
      }
      return true; //isValid
    },
    q_invalid_answer_help_text: "Please enter a value above 0",
    a_error: false,
  },
  {
    q_id: "00000",
    q_title: "City tax",
    q_description: () => {
      return "What is actual or estimated city taxe? What is the frequency of payments? What size monthly cushion do you want to apply (many lenders use 2 as default)? When is the first payment date?";
    },
    node_type: "node",
    a_type: "escrowRow",
    // a_input_type: "number",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) {
        return false; //isValid
      }
      return true; //isValid
    },
    q_invalid_answer_help_text: "Please enter a value above 0",
    a_error: false,
  },
  {
    q_id: "000000",
    q_title: "School tax",
    q_description: () => {
      return "What is actual or estimated school tax? What is the frequency of payments? What size monthly cushion do you want to apply (many lenders use 2 as default)? When is the first payment date?";
    },
    node_type: "node",
    a_type: "escrowRow",
    // a_input_type: "number",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) {
        return false; //isValid
      }
      return true; //isValid
    },
    q_invalid_answer_help_text: "Please enter a value above 0",
    a_error: false,
  },
  {
    q_id: "0000000",
    q_title: "Flood insurance",
    q_description: () => {
      return "What is actual or estimated flood insurance payment? What is the frequency of payments? What size monthly cushion do you want to apply (many lenders use 2 as default)? When is the first payment date?";
    },
    node_type: "node",
    a_type: "escrowRow",
    // a_input_type: "number",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) {
        return false; //isValid
      }
      return true; //isValid
    },
    q_invalid_answer_help_text: "Please enter a value above 0",
    a_error: false,
  },
  {
    q_id: "00000000",
    q_title: "Calculation name",
    q_description: () => {
      return "What would you like to name this calculation. Ex. 'Escrow calc for 777 Happy Choice Rd.' ";
    },
    node_type: "node",
    a_type: "text",
    a_input_type: "text",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) {
        return false; //isValid
      }
      return true; //isValid
    },
    q_invalid_answer_help_text: "",
    a_error: false,
  },
  {
    q_id: "000000000",
    q_title: "Address (optional)",
    q_description: () => {
      return "Enter property address to help organize your calculations. You can also enter a state, zip or nothing, since this field is optional.";
    },
    node_type: "node",
    a_type: "address",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) {
        return false; //isValid
      }
      return true; //isValid
    },
    q_validation_func: (answerVal) => {
      //   make sure not false and a string of none 0 length
      if (!answerVal && !answerVal.length > 0) {
        return false;
      }
      return true; //isValid
    },
    q_invalid_answer_help_text: "Please enter or select an address",
    a_error: false,
  },
];

export default CalculatorQuestions;
